/*
 * Store all string references to classes here.
 * 
 *
 */

module.exports = {
	a : "active",
	d : "disabled",
	h : "hidden"
	
};


/** WEBPACK FOOTER **
 ** ./src/js/models/classes.js
 **/